const FunnelSVG = (): JSX.Element => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 0H0L4.96552 6.05217V12L7.03448 10.0174V6.05217L12 0Z" fill="#EC6823" />
    </svg>
  )
}

export default FunnelSVG
